<script>
import tableMixin from '@/mixins/table'
import api from '@/helpers/api'

export default {
  name: 'settings.translations',
  mixins: [tableMixin],
  data () {
    return {
      isLoading: false,
      search: null,
      showForm: false,
      selectedItem: {},
      fields: [
        {
          key: 'key',
          label: 'Key',
          thStyle: { width: '350px' },
          class: ' align-middle text-truncate'
        },
        {
          key: 'translation',
          label: 'Translation',

          class: ' align-middle text-truncate'
        },
        {
          key: 'locale',
          label: 'Language',
          thStyle: { width: '150px' },
          class: 'text-center  align-middle'
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
          thStyle: { width: '100px' },
          class: 'text-right align-middle'
        }
      ]
    }
  },
  mounted () {
    this.onRefresh()
  },
  watch: {
    customer_id: 'onRefresh',
    search: 'onRefresh',
    currentPage: 'onRefresh',
    perPage: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.currentPage = 1
        }
        this.onRefresh()
      }
    }
  },
  methods: {
    async onRefresh () {
      this.isLoading = true
      this.selectedItem = {}
      let { items, total_rows } = await api.i18NTranslation.fetchPage({
        page: this.currentPage,
        pageSize: this.perPage === 'All' ? -1 : this.perPage,
        needle: this.search,
        sortBy: { key: 'asc', locale: 'asc' },
        filters: []
      })
      this.data = [...items]
      this.totalRows = total_rows
      this.isLoading = false
    },
    onEdit (item) {
      this.selectedItem = item
      this.showForm = true
    },

    onNewTranslation () {
      this.selectedItem = {}
      this.showForm = true
    },
    async onRemove (translation) {
      if (translation === undefined) return
      try {
        this.isLoading = true
        await api.i18NTranslation.delete({
          key: translation.key,
          locale: translation.locale
        })
        this.$bvToast.toast(`Translation '${translation.key}' was removed!`, {
          title: 'Translation Removed',
          solid: true,
          toaster: 'b-toaster-top-center',
          variant: 'success',
          autoHideDelay: 1000,
          appendToast: true
        })
        this.isLoading = false
        this.onRefresh()
      } catch (err) {
        this.$bvToast.toast(`${err}!`, {
          title: 'Error',
          solid: true,
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          autoHideDelay: 1000,
          appendToast: true
        })
        this.isLoading = false
      }
    }
  },
  computed: {}
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title">Translations</h4>
      <div class="my-4 d-flex justify-content-between align-items-center">
        <g-search-input
          v-model="search"
          placeholder="Find Translations"
          width="300px"
          class="mr-0 mr-2"
        /><b-btn
          class="btn-label"
          variant="primary"
          v-on:click="onNewTranslation"
        >
          <i class="bx bx-plus label-icon"></i>New Translation
        </b-btn>
      </div>
      <b-table
        :show-empty="true"
        hover
        :items="data"
        :fields="fields"
        :busy="isLoading"
        head-variant="primary"
        thead-tr-class="border-bottom bg-light"
        tbody-tr-class="border-bottom "
        borderless
        small
      >
        <template v-slot:cell(actions)="row">
          <div class="d-flex align-items-center m-0 p-0">
            <b-button
              variant="link"
              size="sm"
              @click="onEdit(row.item)"
              class="align-self-center mr-1"
            >
              <i class="far fa-edit"></i>
            </b-button>
            <b-button
              variant="link"
              size="sm"
              @click="onRemove(row.item)"
              class="align-self-center"
            >
              <i class="fas fa-trash-alt text-danger"></i>
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="d-flex align-items-center justify-content-between p-0 mt-2">
        <div class="dataTables_length" v-if="totalRows > minPerPage">
          <label class="d-inline-flex align-items-center m-0">
            Show
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="mx-2"
            ></b-form-select
            >Entries
          </label>
        </div>

        <b-pagination
          v-if="perPage !== 'All' && totalRows > perPage"
          class="pagination mb-0"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
        >
          <template v-slot:page="{ page, active }">
            <b v-if="active">{{ page }}</b>
            <i v-else>{{ page }}</i>
          </template>
        </b-pagination>
      </div>
      <app-translation-form-dialog
        :visible.sync="showForm"
        :id="selectedItem.key"
        :locale="selectedItem.locale"
        ref="translation-form"
        v-on:created="onRefresh"
      />
    </b-card>
  </g-overlay>
</template>
